export default __webpack_public_path__ + "static/media/imagePlaceholder.2fc018a4.svg";